import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

class SchedulePanel extends React.Component {
    render() {
        return (
            <div className={`schedule-panel ${this.props.className ? this.props.className : ''}`}>
                <div className="title wk-border-line-after wk-position-rlt">
                    {this.props.title}
                </div>
                <div className="content" style={this.props.isNoPadding ? {padding: 0} : {}}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default SchedulePanel


// WEBPACK FOOTER //
// ./src/pages/schedule/SchedulePanel.js